import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-filter",
  "use": "icon-filter-usage",
  "viewBox": "0 0 512 304",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 512 304\" id=\"icon-filter\"><title>filter</title><path d=\"M176,5a60.1,60.1,0,0,0-56.56,40H0V85H119.44a60,60,0,0,0,113.12,0H512V45H232.56A60.1,60.1,0,0,0,176,5Zm0,40a20,20,0,1,1-20,20A20,20,0,0,1,176,45Z\" transform=\"translate(0 -5)\" /><path d=\"M368,189a60.1,60.1,0,0,0-56.56,40H0v40H311.44a60,60,0,0,0,113.12,0H512V229H424.56A60.1,60.1,0,0,0,368,189Zm0,40a20,20,0,1,1-20,20A20,20,0,0,1,368,229Z\" transform=\"translate(0 -5)\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol